<template>
    <b-modal v-if="dataForPayment" id="payment_modal" @hide="$emit('close')" v-model="show" title="Оплата членского взноса" cancel-title="Отмена" ok-title="Оплата произведена" @ok="reload">
        <p v-if="fetching_qr">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Генерация QR-кода СБП
        </p>

        <p v-if="qrCodeImage" style="text-align: center">
            <img :src="'data:' + qrCodeImage.mediaType + ';base64,' + qrCodeImage.content" width="300" />
        </p>

        <p v-if="!fetching_qr && isAutoProlongationWanted" style="font-size: smaller">
            <em>Внимание!</em> Автопродление членства при оплате через QR-код будет невозможно.
        </p>

        <p v-if="!fetching_qr" style="font-size: smaller">
            Не получается оплатить с помощью <a href="{{ this.paymentUrl }}" target="_blank">Системы быстрых платежей</a>? Перейдите <a href="#" @click.prevent="toCardPayment">к оплате банковской картой</a>.
        </p>
    </b-modal>
    <b-modal v-else id="payment_modal" @hide="$emit('close')" v-model="show" title="Оплата членского взноса" ok-title="ОК" @ok="$emit('close')">
       <p>
         Ошибка ответа платежного сервиса. Пожалуйста, повторите попытку позднее.
       </p>
    </b-modal>
</template>

<script>
import API from '@/utils/api';

export default {
    props: {
        dataForPayment: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            show: true,
            fetching_qr: false,
            qrCodeImage: null,
            paymentUrl: '#',
        }
    },
    computed: {
        isAutoProlongationWanted() {
            return !!this.dataForPayment?.autoProlongationEnabled;
        },
    },
    methods: {
        reload() {
            window.location.reload();
        },
        toCardPayment() {
            this.$store.dispatch('payForMembership', this.dataForPayment);
        },
        async getPaymentUrl() {
            await this.$store.dispatch('getPaymentData', this.dataForPayment)

            this.paymentUrl = this.$store.state.paymentUrl;
        },
    },
    mounted() {
        this.fetching_qr = true;

        // Оплаты онлайн пока нет
        // this.getPaymentUrl();

        (new API()).registerPaymentQR(
            JSON.stringify(this.dataForPayment)
        ).then(responseData => {
            this.qrCodeImage = responseData.image;
            this.paymentUrl = responseData.url;
        }).catch(error => {
            console.error('Ошибка при получении QR-кода для оплаты:', error);
        }).finally(() => {
            this.fetching_qr = false;
        });
    }
}
</script>
